import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EPublishPeriod } from '../../../../../../../json_query';
import { getTermValue } from '../../../../../../../json_query/reducers/helpers';
import { changePublishPeriod } from '../../../../../../state/advanced/publish_period';
import { changeWithPhoto } from '../../../../../../state/with_photo';
import { changeHasVideo } from '../../../../../../state/video';

import { Publish as PublishComponent } from './publish';

export const Publish = connect(
  (state: IAppState) => {
    const { publish_period } = state.filters.jsonQuery;

    return {
      publishPeriod: (publish_period && publish_period.value) || EPublishPeriod.Any,
      withPhoto: !!(state.filters.jsonQuery.wp && state.filters.jsonQuery.wp.value),
      withVideo: !!getTermValue('has_video')(state.filters.jsonQuery),
    };
  },
  (dispatch: Dispatch) => ({
    onPublishPeriodChange: (value: EPublishPeriod) => {
      dispatch(changePublishPeriod(value));
    },
    onWithPhotoChange: (value: boolean) => {
      dispatch(changeWithPhoto(value));
    },
    onWithVideoChange: (value: boolean) => {
      dispatch(changeHasVideo(value));
    },
  }),
)(PublishComponent);
